/** @jsx jsx */
import { Button, Container, jsx } from 'theme-ui'
import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
    }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo)
  }

  handleCallback(callback) {
    if (typeof callback === 'function') {
      callback()
      return (this.state.hasError = false)
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Container>
          <h1>Something went wrong.</h1>
          {this.props?.callbackTitle && this.props?.handleCallback && (
            <Button
              onClick={() => this.handleCallback(this.props?.handleCallback)}
            >
              {this.props?.callbackTitle}
            </Button>
          )}
        </Container>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
